export class InvalidChatSessionError extends Error {

}